<template>
  <div class="content-page">
    <!-- Start content -->
    <div class="content">
      <div class="container-fluid">
        <div class="page-title-box">
          <div class="row align-items-center">
            <div class="col-sm-5">
              <h4 class="page-title">
                <font color="white">SETTLEMENTS</font>
              </h4>
            </div>
            

            <div class="col-sm-5">
              <div class="float-right d-none d-md-block">
                <li class="d-none d-sm-block">
                  <div class="dropdown pt-3 d-inline-block">
                      

                    <a
                      class="btn btn-light dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >{{filter}}</a>

                   

                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <form>
                        <a class="dropdown-item">
                          <label>Start Date</label>
                          <input type="date" v-model="start_date" class="form-control" />
                          <label>End Date</label>
                          <input type="date" v-model="end_date" class="form-control" />
                        </a>
                        <a class="dropdown-ite">
                          <button
                            type="reset"
                            class="btn btn-secondary waves-effect waves-light float-left"
                          >Reset</button>
                          <div></div>
                          <button
                            type="button"
                            @click="filterTransaction()"
                            class="btn dropdown-toggle btn-success waves-effect waves-light float-right"
                            data-toggle="dropdown"
                            id="filter-btn"
                          >Filter</button>
                        </a>
                      </form>
                    </div>
                  </div>
                </li>
              </div>

            </div>
               <div class="form-group" style="display:inline-block; margin-left: 10px; margin-buttom: unset !important;">
                    <select id="inputState" class="form-control" style="margin-top: 30px;" @change="setDesiredBranch($event)">
                        <option selected value="">All Branch</option>
                        <option  v-for="branch in branches" :key="branch.branch_id" :value="branch.branch_id">{{ branch.branch_name }}</option>
                    </select>
                </div>
          </div>
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <table
                  v-if="!spinner"
                  id="example"
                  class="table table-striped table-bordered dt-responsive nowrap text-center"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;"
                >
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Recipient</th>
                      <th>Amount (NGN)</th>
                      <th>Amount Paid (NGN)</th>
                      <th>When</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="payouts.length == 0">
                      <td colspan="5">No recent Payouts yet..</td>
                    </tr>
                    <tr v-else v-for="(item, index) in payouts" :key="index">
                      <td>
                        <i
                          :class="[(item.status.toLowerCase() == 'processing')?'fa fa-circle text-warning': 'fa fa-circle text-success']"
                        ></i>
                        {{ item.status }}
                      </td>
                      <td>{{ item.recipient }}</td>
                      <td>{{ formatNumber(item.amount) }}</td>
                      <td>
                        <strong>{{ formatNumber(item.amount_paid) }}</strong>
                      </td>

                      <td>{{ item.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="spinner" class="text-center">
                <p>
                  <i class="fa fa-spinner fa-spin fa-3x"></i>
                </p>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
    <!-- content -->
  </div>
</template>
<script>
import { setTimeout } from "timers";
let table = null;

export default {
  mounted() {
    this.fields.username = sessionStorage.getItem("username");
    this.fields.user_id = sessionStorage.getItem("userid");
    this.getBranch();
    setTimeout(() => {
     table = $("#example").DataTable({
       destroy: true,
        order: [[4, "desc"]],
        dom: "Bfrtip",
        buttons: ["copyHtml5", "excelHtml5", "csvHtml5", "pdfHtml5"]
      });
    }, 2000);
  },
  beforeUpdate()
  {
    table.destroy();
  }
  ,
  data() {
    return {
      fields: {
        action: "payout_transactions",
        service: "payout",
        branch: ''
      },
      payouts: [],
      start_date: null,
      end_date: null,
      filter: "Filters",
      spinner: false,
      branch: '',
      branches: null,
    };
  },
  methods: {
    hash(ref) {
      let passcode = "123NDSx";
      let encrypted = CryptoJS.HmacSHA512(ref, passcode);
      return encrypted.toString();
    },

     getBranch(){
                this.spinner = true;
                let user_id = sessionStorage.getItem("userid");
                let username = sessionStorage.getItem("username");

                var obj = {
                    'action': 'get_branches', 
                    'username': username,
                    'user_id':user_id,
                    'passcode':this.hash(username)
                };

               
                this.axios.post("https://irecharge.com.ng/api/collections/get_branches.php",obj)
                .then(response => {
                    if (response.data.status == "0") {
                        this.branches = response.data.items
                        // this.spinner = false;
                        this.getPayout();

                    } else {
                        if (response.data.message) {
                            this.$noty.error(response.data.message);
                            this.spinner = false;

                        }
                    
                    }
                
                    }).catch(error => {
                        this.$noty.error("Error occured. Try again");
                    });

                {
            
            }

        },

        setDesiredBranch(event)
      {
        this.branch = event.target.value;
        this.getPayout();
      },

    getPayout() {
      //show the loader
      this.spinner = true;


      this.fields.passcode = this.hash(this.fields.username);
      this.fields.branch = this.branch;
      this.axios
        .post(
          "https://irecharge.com.ng/api/collections/payout_transactions.php",
          this.fields
        )
        .then(response => {
          //console.log(response.data);
          if (response.data.status == "0") {
            if (response.data.transactions) {
              this.payouts = response.data.transactions;
            }
            //change the filter text if this is actually filtered
            if (this.start_date != null && this.end_date != null) {
              this.filter =
                "Filtered By: from " + this.start_date + " to " + this.end_date;
              $("filter-btn").dropdown("toggle");
            }
          } else {
            this.$noty.warning(response.data.message);
          }
          this.spinner = false;

        })
        .catch(error => {
          //console.log('error')
          //console.log(error)
          this.spinner = false;
        });
    },
    filterTransaction() {
      //console.log(this.fields);
      if (this.start_date != null && this.end_date != null) {
        this.fields.start_date = this.start_date;
        this.fields.end_date = this.end_date;
        this.getPayout();
      }
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }
};
</script>
<style scoped>
</style>